// extracted by mini-css-extract-plugin
module.exports = {"flavor":"TxN1us_7aJhfYe25egRD","flavorDescription":"fPkJZPh7zPxAEiojR3LX","map":"XpfRNMkUxTFsh71eGArx","link":"WkwSc4CgQNmTG_nVL2hG"};